import { useLang } from "@/context/LanguageContext";
import { IMAGES } from "@/data/images";
import { PageHero } from "@/components/PageHero";
import { PhotoCard, CardGrid } from "@/components/Cards";

export default function Activities() {
  const { content } = useLang();
  const { activities } = content;
  return (
    <>
      <PageHero label={activities.title} title={activities.heading} intro={activities.intro} image={IMAGES.activities} />
      <section className="bg-white" data-testid="activities-grid-section">
        <div className="container-x pt-8 pb-20 md:pt-10 md:pb-28">
          <CardGrid cols="sm:grid-cols-2 lg:grid-cols-3" className="gap-y-14">
            {activities.sections.map((d) => (
              <PhotoCard key={d.slug} to={`/activites/${d.slug}`} image={IMAGES.departments[d.slug]} title={d.title} text={d.text} cta={d.cta} testid={`activity-card-${d.slug}`} />
            ))}
          </CardGrid>
        </div>
      </section>
    </>
  );
}
